export enum ProfileModelType {
  CONSERVATIVE = 'CONSERVATIVE',
  MODERATE = 'MODERATE',
  AGGRESSIVE = 'AGGRESSIVE',
  CUSTOM = 'CUSTOM'
}

export enum PortfolioAllocationStatus {
  BALANCED = 'BALANCED',
  OUT_OF_BALANCE = 'OUT_OF_BALANCE'
}

export enum RebalancePeriod {
  MONTHLY = 'MONTHLY',
  QUARTERLY = 'QUARTERLY',
  ANNUALLY = 'ANNUALLY',
  NOT_APPLICABLE = 'NOT_APPLICABLE'
}

export enum RebalanceType {
  PERIOD = 'PERIOD',
  DRIFT = 'DRIFT'
}

export enum AssetStatus {
  OVER = 'OVER',
  UNDER = 'UNDER',
  BALANCED = 'BALANCED'
}
